import React, { useCallback } from 'react';
import {
  DndContext,
  closestCenter,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import {
  SortableContext,
  arrayMove,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { AnunciosI } from '../../models/home';
import SortableAnuncioItem from './SortableAnuncioItem';

interface MultipleAnunciosDropzoneProps {
  anuncios: AnunciosI;
  setAnuncios: (anuncios: AnunciosI) => void;
  onRemove: (index: number) => void;
  title: string;
}

const MultipleAnunciosDropzone: React.FC<MultipleAnunciosDropzoneProps> = ({
  anuncios,
  setAnuncios,
  onRemove,
  title,
}) => {
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 5,
      },
    })
  );

  const handleDrop = useCallback(
    (e: React.DragEvent<HTMLDivElement>) => {
      e.preventDefault();
      const files = Array.from(e.dataTransfer.files).filter((file) =>
        file.type.startsWith('image/') || file.type === 'image/gif'
      );

      console.log(files)

      const nuevos = files.map((file, i) => ({
        media: file,
        imagen: URL.createObjectURL(file),
        tipo: 'anuncio_productos',
        orden: anuncios?.length + i,
      }));

      console.log(nuevos)

      setAnuncios([...(anuncios || []), ...nuevos]);

      console.log(anuncios)
    },
    [anuncios, setAnuncios]
  );


  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
  };

  const handleDragEnd = (event: any) => {
    const { active, over } = event;
    if (active.id !== over?.id) {
      const oldIndex = anuncios.findIndex((i) => i.orden === active.id);
      const newIndex = anuncios.findIndex((i) => i.orden === over.id);
      const reordenados = arrayMove(anuncios, oldIndex, newIndex);

      // Reasignar el campo 'orden' según la nueva posición
      const conOrden = reordenados.map((img, i) => ({ ...img, orden: i }));
      setAnuncios(conOrden);
    }
  };


  return (
    <div>
      <label>{title}(arrástralos aquí)</label>
      <div
        onDrop={handleDrop}
        onDragOver={handleDragOver}
        style={{
          border: '2px dashed #ccc',
          padding: '20px',
          marginBottom: '20px',
          textAlign: 'center',
          borderRadius: '8px',
        }}
      >
        Suelta aquí tus imágenes o GIFs
      </div>

      <DndContext
        sensors={sensors}
        collisionDetection={closestCenter}
        onDragEnd={handleDragEnd}
      >
        <SortableContext
          items={anuncios?.map((anuncio) => anuncio.orden)}
          strategy={verticalListSortingStrategy}
        >
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {anuncios?.map((anuncio, index) => (
              <SortableAnuncioItem
                key={index}
                anuncio={anuncio}
                index={index}
                onRemove={onRemove}
                onUrlChange={(idx, url) => {
                  const updated = [...anuncios];
                  updated[idx] = { ...updated[idx], url };
                  setAnuncios(updated);
                }}
              />
            ))}
          </div>
        </SortableContext>
      </DndContext>
    </div>
  );
};

export default MultipleAnunciosDropzone;
